<template>
    <v-container fluid>
        
        <InfoAlert :showDismissibleAlert="showDismissibleAlert" :info="info" v-on:close="showDismissibleAlert=false" />
<v-row>
    <v-col>
 <v-form
    ref="orgForm"
    v-model="valid"
    
  >
      <v-card  :dark="$store.getters.getColorPalette().isDark">
        <v-card-title class="headline">
         {{ $store.getters.getTextMap().create_word}}
        </v-card-title>
        <v-card-text>
            <v-text-field
            :dark="$store.getters.getColorPalette().isDark"
      v-model="form.name"
      :counter="46"
      :rules="[rules.required]"
      :label=" $store.getters.getTextMap().name"
      :loading="loading"
      required
    ></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
          :color="$store.getters.getColorPalette().submitbtnColor"
           
            @click="onSubmit"
          >
        {{$store.getters.getTextMap().submit}}
          </v-btn>
          <v-btn
           :color="$store.getters.getColorPalette().cancelbtnColor"
           :dark="$store.getters.getColorPalette().isDark"
            @click="onReset"
          >
          {{$store.getters.getTextMap().cancel}}
          </v-btn>
        </v-card-actions>
      </v-card>
      </v-form>
    </v-col>
</v-row>
    </v-container>
</template>
<script>
import axios from 'axios';
import InfoAlert from '@/components/InfoAlert'
import FormRules from '@/utillities/FormRules'
export default {
    name:'AddHub',
    components:{
        InfoAlert
    },
    data(){
        return {
            form:{
                hub_id:null
            },
                loading:false,
                info:null,
                showDismissibleAlert:false,
                valid:false,
                rules:FormRules.rules,
        nameRules: [
        v => !!v || 'required',
        v => /\S+/.test(v) || 'required',
        v => (v && v.length <= 4 && v.length > 0) || 'ID must be less than 4 characters',
      ],
        }
    },
    methods:{
        onSubmit(){
            //evt.preventDefault();
            this.$refs.orgForm.validate()
            if(this.valid){
            this.loading = true;
      axios
        .post(this.$store.state.api + "addWordRef", this.form,{headers: {
      Authorization: 'Bearer '+ this.$store.state.jwt
    }})
        .then(response => {
          if (response.data.status == "success") {
            
            
            //console.log(response.data.jwt);
            this.$store.dispatch("refreshWords");
            
           
            this.info = "Word added";
          this.showDismissibleAlert = true;
          this.loading = false;
            this.onReset()
            this.$emit('close')
          } else {
            this.info = response.data.msg;
            this.showDismissibleAlert = true;
          }
          //this.onReset()
          this.loading = false;
        })
        .catch(error => {
          this.onReset()
          this.info = error;
          this.showDismissibleAlert = true;
          this.loading = false;
        });
            }
        },
        onReset(){
            this.$refs.orgForm.reset()
            
            
            
        }
    }
}
</script>
